import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
const PageHero = ({ title, product }) => {
  return (
    <Wrapper>
      <h2>
        <Link to="/">Home</Link>
        {" / "}
        {product && (
          <>
            <Link to="/products">Products</Link>
            {" / "}
          </>
        )}

        <span>{title.toLowerCase()}</span>
      </h2>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  padding: 8vh 10vw;
  background-color: var(--color-primary-6);
  display: flex;
  align-items: center;
  color: var(--color-primary-4);
  font-size: 1.5em;
  font-weight: 700;
  a,
  h2 {
    /* font-family: var(--font-family-2); */
    > span {
      text-transform: capitalize;
    }
  }
  a {
    color: var(--color-primary-3);
    text-decoration: none;
  }
  a:hover {
    color: var(--color-primary-4);
  }
  @media screen and (max-width: 600px) {
    font-size: 1em;
    padding: 5vh 5vw;
  }
`;

export default PageHero;
